// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df1f81be","455":"0feaa5c6","977":"9cca50bf"}[chunkId] + ".chunk.js";
};